<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div class="p-3">
      <h2 class="mb-5">Role Permission Setup</h2>
      <div class="row">
        <div class="col-md-4 mb-2">
          <div class="rounded-3 border me-2 p-3" style="background-color: white;">
            <div class="d-grid gap-2 my-4">
              <select v-model="selectedRole" class="py-2 border border-secondary rounded px-2 mb-2"
                      @change="selectRole">
                <option :value=null disabled>-- Select Role --</option>
                <option v-for="(roleInfo, index) in fetchedRoles" :key="index" :value="roleInfo.role_id">
                  {{ roleInfo.role_name }}
                </option>
              </select>
              <div :class="{ disabled: showSection == 'menu' }" class="btn btn-primary d-flex "
                   style="text-align: center;"
                   @click="showSection = 'menu'">
                <i class="fa-solid fa-bars align-self-center me-2"></i>
                <div class="align-self-center menu-button">
                  Application Menus
                </div>
              </div>
              <div :class="{ disabled: showSection == 'permission' }" class="btn btn-primary d-flex"
                   style="text-align: center; " @click="showSection = 'permission'">
                <i class="fa-solid fa-user-lock align-self-center me-2"></i>
                <div class="align-self-center menu-button">
                  Permissions
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-8 ">
          <div v-if="loading">
            <div class="text-center mb-3 d-flex justify-content-center">
              <b-spinner variant="primary"></b-spinner>
            </div>
          </div>
          <div v-else-if="showSection === 'menu'" class="rounded-3 border p-4" style="background-color: white;">
            <div class="d-flex flex-row mb-3">
              <div style="font-size: 20px; font-weight: 500;">
                Application Menus
              </div>
              <div class="ms-3 btn btn-success" @click="saveRoleMenu">Save</div>
            </div>
            <hr style="background-color: gray"/>
            <div style="max-height: 50vh;overflow: auto">
              <div v-for="(menuInfo, menuIndex) in fetchedMenus" :key="menuIndex">
                <div class="mb-2">
                  <div class="align-self-center d-flex flex-row">
                    <input :id="'menu' + menuInfo.main_menu_id" v-model="savedRoleInfo.menu_id"
                           :value="menuInfo.main_menu_id" class="checkbox-input me-2"
                           style="align-self: center;" type="checkbox"
                           @change="selectMenu(menuIndex)">
                    <!--                                       @change="(e) => allChildSelected(e,menuInfo.child)"-->

                    <div v-if="menuInfo.child != null && menuInfo.child.length != 0"
                         style="align-self: center;font-size: 16px;">
                      {{ menuInfo.main_menu_name }}
                    </div>
                    <div v-else style="align-self: center;font-size: 16px;">
                      {{ menuInfo.main_menu_name }}
                    </div>
                  </div>
                  <div v-if="menuInfo.child != null && menuInfo.child.length != 0"
                       :id="menuInfo.main_menu_id" class="collapse show my-2">
                    <div v-for="(childInfo, childIndex) in menuInfo.child" :key="childIndex"
                         class="ms-5 d-flex flex-row">
                      <input :id="childInfo.menu_id" v-model="savedRoleInfo.sub_menu_id" :value="childInfo.menu_id"
                             class="checkbox-input me-2" style="align-self: center;"
                             type="checkbox">
                      <div style="align-self: center;font-size: 15px">
                        {{ childInfo.menu_name.replaceAll('_', ' ') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div v-else-if="showSection === 'permission'" class="rounded-3 border p-4" style="background-color: white;">
            <div class="d-flex flex-row mb-3">
              <div style="font-size: 20px; font-weight: 500;">
                Permissions
              </div>
              <div class="ms-3 btn btn-success" @click="savePermissions">Save</div>
            </div>
            <hr style="background-color: gray"/>
            <div v-for="(permissionInfo, permissionIndex) in fetchedPermissions" :key="permissionIndex">
              <div class="mb-2">
                <div class="align-self-center d-flex flex-row">
                  <input :id="'perm' + permissionInfo.id" v-model="savedRoleInfo.permissionList"
                         :value="permissionInfo.id"
                         class="checkbox-input me-2" style="align-self: center;"
                         type="checkbox">
                  <div style="align-self: center;font-size: 16px;">
                    {{ permissionInfo.name }}
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {notify} from "@kyvg/vue3-notification";
import RoleService from '@/services/role.service';
import menuService from '@/services/menu.service';
import PermissionService from '@/services/permission.service';

import dashboardService from "@/services/dashboard.service";

export default {
  name: "AddUserPage",
  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'User',
          to: '/users/add'
        }, {
          text: 'Assign Permission',
          href: '#'
        }
      ],
      selectedRole: null,
      showSection: 'menu', // menu, permission
      savedRoleInfo: {
        role_id: null,
        main_menu_id: null,
        sub_menu_id: [],
        menu_id: [],
        permissionList: [],
      },
      loading: false,
      fetchedRoles: [],
      fetchedPermissions: [],
      fetchedRolePermissions: [],
      fetchedMenus: null,
    };
  },
  computed: {
    rolesArray: function () {
      return this.fetchedRoles.filter(i => i.active_yn === 'Y')
    },
  },
  created() {
    this.fetchAllMenus();
    this.fetchPermissions();
    this.fetchRoles();
  },
  methods: {
    selectMenu(menuIndex) {
      // if (this.savedRoleInfo.menu_id.includes(this.fetchedMenus[menuIndex].main_menu_id)) {
      if (this.fetchedMenus[menuIndex].child != null && this.fetchedMenus[menuIndex].child.length != 0) {
        this.fetchedMenus[menuIndex].child.forEach(submenu => {
          if (this.savedRoleInfo.menu_id.includes(this.fetchedMenus[menuIndex].main_menu_id)) {
            if (!this.savedRoleInfo.sub_menu_id.includes(submenu.menu_id)) {
              this.savedRoleInfo.sub_menu_id.push(submenu.menu_id);
            }
          } else {
            if (this.savedRoleInfo.sub_menu_id.includes(submenu.menu_id)) {
              const index = this.savedRoleInfo.sub_menu_id.indexOf(submenu.menu_id);
              if (index > -1) {
                this.savedRoleInfo.sub_menu_id.splice(index, 1);
              }
            }
          }
        });
      }
    },
    async fetchAllMenus() {
      this.loading = true;
      try {
        const response = await dashboardService.getAllMenus();
        this.loading = false;
        this.fetchedMenus = response.data;
      } catch (error) {
        this.loading = false;
      }
    },
    async fetchRoles() {
      this.loading = true;
      try {
        const response = await RoleService.fetchRole();
        this.loading = false;
        if (response.data) {
          this.fetchedRoles = response.data
        }
      } catch (error) {
        this.loading = false;
      }

    },
    async fetchPermissions() {
      this.loading = true;
      try {
        const response = await PermissionService.getPermissionList();
        this.loading = false;
        if (response.data) {
          this.fetchedPermissions = response.data
        }
      } catch (error) {
        this.loading = false;
      }
    },
    async getPermissionByRoleId(role_id) {
      this.savedRoleInfo.permissionList = [];
      this.loading = true;
      try {
        const response = await PermissionService.getPermissionsByRoleID(role_id);
        this.loading = false;
        if (response.data) {
          response.data.forEach(element => {
            this.savedRoleInfo.permissionList.push(element.id);
          });
        }
      } catch (error) {
        this.loading = false;
        notify({
          type: "error",
          title: "Get Permissions",
          text: "Something went wrong",
        });
      }
    },
    async getmenusByRole(role_id) {
      this.loading = true;
      try {
        const response = await menuService.getMainMenuListByRole(role_id);
        this.loading = false;
        if (response.data) {
          this.savedRoleInfo.menu_id = response.data.mainMenuList;
          this.savedRoleInfo.sub_menu_id = response.data.subMenuList;
        }
      } catch (error) {
        this.loading = false;
      }
    },
    async savePermissions() {
      var reqBody = {
        "role_id": this.selectedRole,
        "permission_ids": this.savedRoleInfo.permissionList,
      };
      const response = await PermissionService.savePermissionOfRole(reqBody);
      if (response.data) {
        if (response.data['messageCode'] == 1) {
          notify({
            type: "success",
            title: "Assign Permission",
            text: response.data.message,
          });
        } else {
          notify({
            type: "error",
            title: "Assign Permission",
            text: response.data.message,
          });
        }
      }
    },
    async saveRoleMenu() {
      this.loading = true;
      this.savedRoleInfo.role_id = this.selectedRole;
      var filtered = this.savedRoleInfo.sub_menu_id.filter(function (el) {
        return el != null;
      });
      this.savedRoleInfo.sub_menu_id = filtered;
      var response;
      try {
        response = await menuService.saveRoleMenu(this.savedRoleInfo);
      } catch (error) {
        this.loading = false;
        notify({
          type: "error",
          title: "Assign Role",
          text: error,
        });
        return;
      }
      this.loading = false;

      if (response.data) {
        if (response.data['messageCode'] == 1) {
          notify({
            type: "success",
            title: "Assign Role",
            text: response.data.message,
          });
        } else {
          notify({
            type: "error",
            title: "Assign Role",
            text: response.data.message,
          });
        }
      }
    },
    selectRole() {
      this.getPermissionByRoleId(this.selectedRole);
      this.getmenusByRole(this.selectedRole);
    },
  },
};
</script>
<style scoped>
.userInputField {
  width: 95%;
  margin-bottom: 10px;
}

.rightBars {
  width: 50%;
  margin-bottom: 10px;
}

.menu-button {
  font-size: 16px;
}
</style>